document.addEventListener('DOMContentLoaded', function () {
  var t = document.querySelector('[data-menu-toggle]'), n = document.querySelector('[data-nav]');
  if (t && n) t.addEventListener('click', function () {
    var o = n.classList.toggle('open'); t.setAttribute('aria-expanded', o);
  });
  var m = document.getElementById('main-img');
  document.querySelectorAll('.thumb').forEach(function (b) {
    b.addEventListener('click', function () { if (m) { m.removeAttribute('srcset'); m.src = b.dataset.full; } });
  });
  document.querySelectorAll('[data-sort]').forEach(function (s) {
    s.addEventListener('change', function () {
      var u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); location.href = u.toString();
    });
  });
});
